import { createContext } from 'react';

export const LeadContext = createContext({});
